import React from 'react';
import { InnoFooter, InnoFooterItem, InnoIcon } from '@innomotics/innomotics-build-react-lib';
import { useTranslate } from '../../hooks/common';
import { TRANSLATIONS } from '../../constants';

const Footer = () => {
    const translate = useTranslate();

    return (
        <footer>
            <div className='footer-container'>
                <InnoFooter variant='dark' copyright={translate(TRANSLATIONS.footer.innomotics).replace('2023 - {date}', new Date().getFullYear().toString())}>
                    <InnoFooterItem slot='links' className='footer-links footer-legal'>
                        <a className='footer-link' target='_blank' href={translate(TRANSLATIONS.footer.corporateInformationLink)} rel='noreferrer'>
                            {translate(TRANSLATIONS.footer.corporateInformation)}
                        </a>
                    </InnoFooterItem>

                    <InnoFooterItem slot='links' className='footer-links footer-legal'>
                        <a className='footer-link' target='_blank' href={translate(TRANSLATIONS.footer.privacyNoticeLink)} rel='noreferrer'>
                            {translate(TRANSLATIONS.footer.privacyNotice)}
                        </a>
                    </InnoFooterItem>

                    <InnoFooterItem slot='links' className='footer-links footer-legal'>
                        <a className='footer-link' target='_blank' href={translate(TRANSLATIONS.footer.cookieNoticeLink)} rel='noreferrer'>
                            {translate(TRANSLATIONS.footer.cookieNotice)}
                        </a>
                    </InnoFooterItem>

                    <InnoFooterItem slot='links' className='footer-links footer-legal'>
                        <a className='footer-link' target='_blank' href={translate(TRANSLATIONS.footer.termsOfUseLink)} rel='noreferrer'>
                            {translate(TRANSLATIONS.footer.termsOfUse)}
                        </a>
                    </InnoFooterItem>

                    <InnoFooterItem slot='links' className='footer-links footer-legal'>
                        <a className='footer-link' target='_blank' href={translate(TRANSLATIONS.footer.digitalIdLink)} rel='noreferrer'>
                            {translate(TRANSLATIONS.footer.digitalId)}
                        </a>
                    </InnoFooterItem>

                    <InnoFooterItem slot='icons' className='footer-links footer-legal'>
                        <a href='https://www.linkedin.com/company/innomotics' title='LinkedIn' target='_blank' rel='noopener noreferrer'>
                            <InnoIcon icon='logo_linkedin' size='24'>
                            </InnoIcon>
                        </a>
                    </InnoFooterItem>

                </InnoFooter>
            </div>
        </footer>
    );
};

export default Footer;
